export const PaymentMetadata = {
  CHECKOUT_ID: 'checkout',
  PLAN_TYPE: 'planType',
  SCOPE: 'scope',
  IMAGE: 'image',
  TOKENS: 'amt',
  REPORT_ID: 'rid',
} as const;
export type TPaymentMetadata = (typeof PaymentMetadata)[keyof typeof PaymentMetadata];

/**
 * sessionStorage key used to bridge a successful subscription purchase across the
 * Stripe redirect (dashboard callback) and the plans dialog reopened on /payment.
 */
export const SUBSCRIPTION_PURCHASE_SUCCESS_KEY = 'subscriptionPurchaseSuccess';
